import ApiService from './api'


export const PayinService = {
    getPayList() {
        return ApiService.get('/payin/systems')
    },

    getCurrencyList() {
        return ApiService.get('/payin/systems/currencies')
    },

    getResult({ amount, system, currency }) {
        return ApiService.get(`/payin/systems/commission?amount=${ amount }&system=${ system }&currency=${ currency }&currency_expected=${ currency }`)
    }
}

export const PayoutService = {
    getPayList() {
        return ApiService.get('/payout/systems')
    },

    getCurrencyList() {
        return ApiService.get('/payout/systems/currencies')
    },

    getResult({ amount, system, currency }) {
        return ApiService.get(`/payout/systems/commission?amount=${ amount }&system=${ system }&currency=${ currency }`)
    }
}
